import axios from 'axios'

export default {
  request (method, uri, data = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    return axios({ method: method, url: uri, data: data })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js